<div class="rating-holder">
  <div [ngClass]="{'representative-rating': !clickable,
                   'clickable-rating': clickable,
                   'rating-sm': ratingStarsSize === 'sm',
                   'rating-lg': ratingStarsSize === 'lg'}"
       class="clearfix"
       [attr.data-rating-value]="displayedValueAttribute">
    <div class="star"
         *ngFor="let grade of grades"
         (click)="setGrade(grade)">
      {{grade}}
    </div>
  </div>
</div>
